<template>
    <div class="People">
        
        <div class="row record-section-row">
            <div class="col">
                <h4>Primary Therapist:</h4>
                <SingleMembershipEditor :fields="[{name: 'Employee.Person.FullName', title: 'NAME'}, {name: 'StartDate', title: 'STARTED', callback: 'formatDate|MM/DD/YY'}, {name: 'EndDate', title: 'ENDED', callback: 'formatDate|MM/DD/YY|N/A'}]"
                                        :field-data="ChildRecordData.PrimaryTherapists"
                                        :edit-mode="EditMode"
                                        select-label="Primary Therapist:"
                                        options-type="API"
                                        options-method="Residential/Clients/People/GetAvailablePrimaryTherapistEmployees"
                                        :options-method-record-id="ChildRecordData.ClientProgramMembership.SubProgramID"
                                        add-record-method="Residential/Clients/People/AssignOrTransferPrimaryTherapist"
                                        add-record-record-property-name="EmployeeID"
                                        :add-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.ClientProgramMembership.Id}"
                                        add-record-modal-title="Add Initial Primary Therapist"
                                        transfer-record-method="Residential/Clients/People/AssignOrTransferPrimaryTherapist"
                                        transfer-record-record-property-name="EmployeeID"
                                        :transfer-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.ClientProgramMembership.Id}"
                                        transfer-record-modal-title="Transfer Primary Therapist"
                                        transfer-record-effective-date-property-name="StartDate"
                                        delete-record-method="Residential/Clients/People/DeleteCurrentPrimaryTherapist"
                                        :delete-record-additional-payload="{Id: ChildRecordData.ClientProgramMembership.Id}"
                                        delete-record-modal-title="Delete Current Case Manager"
                                        delete-record-modal-text="NOTICE: You are about to unassign this child's current Primary Therapist.  If there was a previous Primary Therapist assigned, the child will be re-assigned to them." />
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Professionals:</h4>
                <ContactDisplayAndEdit :edit-mode="EditMode"
                                       :global-update="false"
                                       get-endpoint="Core/Clients/Contacts/Professionals/GetContacts"
                                       :get-payload="{Id: ChildRecordData.ClientProgramMembership.Id}"
                                       add-edit-endpoint="Core/Clients/Contacts/Professionals/AddEditContact"
                                       :add-edit-payload="{ChartID: ChildRecordData.ClientProgramMembership.Id}"
                                       delete-endpoint="Core/Clients/Contacts/Professionals/DeleteContact"
                                       :require-dob="false"
                                       contact-category="Professionals"
                                       :relationship-options="ProfessionalOptions"
                                       relationship-label="Child"
                                       :display-age="false"
                                       :display-relationship="true"
                                       :agency-input="true"
                                       :display-agency="true" />
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Biological Family:</h4>
                <ContactDisplayAndEdit :edit-mode="EditMode"
                                       :global-update="false"
                                       get-endpoint="Core/Clients/Contacts/BiologicalFamily/GetContacts"
                                       :get-payload="{Id: ChildRecordData.ClientProgramMembership.Id}"
                                       add-edit-endpoint="Core/Clients/Contacts/BiologicalFamily/AddEditContact"
                                       :add-edit-payload="{ChartID: ChildRecordData.ClientProgramMembership.Id}"
                                       delete-endpoint="Core/Clients/Contacts/BiologicalFamily/DeleteContact"
                                       :require-dob="false"
                                       contact-category="Biological Family"
                                       :relationship-options="FamilyRelationOptions"
                                       relationship-label="Child"
                                       :display-age="false"
                                       :display-relationship="true"
                                       :agency-input="false"
                                       :display-agency="false" />
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Misc:</h4>
                <ContactDisplayAndEdit :edit-mode="EditMode"
                                       :global-update="false"
                                       get-endpoint="Core/Clients/Contacts/Misc/GetContacts"
                                       :get-payload="{Id: ChildRecordData.ClientProgramMembership.Id}"
                                       add-edit-endpoint="Core/Clients/Contacts/Misc/AddEditContact"
                                       :add-edit-payload="{ChartID: ChildRecordData.ClientProgramMembership.Id}"
                                       delete-endpoint="Core/Clients/Contacts/Misc/DeleteContact"
                                       :require-dob="false"
                                       contact-category="Misc"
                                       :relationship-options="null"
                                       relationship-label="Child"
                                       :display-age="false"
                                       :display-relationship="true"
                                       :agency-input="true"
                                       :display-agency="true" />
            </div>
        </div>
        <div class="row">
            <div class="col padding-top-md pointer" v-on:click="ToggleEditMode()">
                <font-awesome-icon :icon="['fa', 'edit']" />
                <span v-if="EditMode"> Edit Mode: ON</span>
                <span v-else> Edit Mode: OFF</span>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import SingleMembershipEditor from '../../../Core/ItemEditors/SingleMembershipEditor';
    import ContactDisplayAndEdit from '../../../Core/ItemEditors/ContactDisplayAndEdit.vue';
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            ToggleEditMode() {
                this.EditMode = !this.EditMode;
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            }
        },
        components: {
            SingleMembershipEditor,
            ContactDisplayAndEdit
        },
        mounted() {

        },
        computed: {
            GetSubProgramTerminationReasons: function () {
                let subprogram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.ChildRecordData.ClientProgramMembership.SubProgramID);
                let returnObj = [];
                if (subprogram.DischargeReasons.length > 0) {
                    subprogram.DischargeReasons.forEach(function (item) {
                        returnObj.push({ text: item.Label, value: item.Id });
                    })
                }
                return returnObj;
            },
            ProfessionalOptions: function () {
                return this.$store.state.Options.ProfessionalTypes;
            },
            FamilyRelationOptions: function () {
                return this.$store.state.Options.FamilyRelations;
            }
        }    
    }
</script>

<style scoped
</style>